'use strict';

angular.module('translateProviderConfig', ['pascalprecht.translate'])
  .config(function ($translateProvider) {

    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

    $translateProvider.useStaticFilesLoader({
      prefix: 'i18n/locale-',
      suffix: '.json'
    });

    $translateProvider.preferredLanguage('en_us');
    $translateProvider.fallbackLanguage('en_us');

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/i18n/translateProviderConfig.js
// module id = 564
// module chunks = 0